import React from 'react';

const Header = () => {
  return (
    <header className="bg-background text-white p-4 flex justify-between items-center">
      <h1 className="text-xl font-bold">yourcallgirl</h1>
    </header>
  );
};

export default Header;
